import React from "react";
import CapacityListingHeader from "../../Profile/capacityListingNew/capacityListingHeader";
import NodataFound from "../../../commons/Toast/noDataFound";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { useEffect } from "react";
import listingsSearchService from "../../../components/Services/listingsSearch.service";
import "./listingsSearch.css";
import ListingsSearchFilter from "./listingsSearchFilter";
import {
  getAllListingsConsumerLogin,
  getAllListingsGeneratorLogin,
} from "../../../store/ListingsSearch/actions";
import { PreviewModel } from "../previewModel";
import { ConsumerCapacityModal } from "../consumerCapacityModal";
import ca from "date-fns/esm/locale/ca/index.js";
import capacityGeneratorService from "../../../components/Services/capacityGenerator.service";
import biddingGeneratorService from "../../../components/Services/biddingGenerator.service";
import { toast } from "react-toastify";
import { toastProperties } from "../../../commons/Toast/Toaster";
import biddingConsumerService from "../../../components/Services/biddingConsumer.service";
import { getSpeceficTradersNew } from "../../../store/Analyst/action";
import capacityConsumerService from "../../../components/Services/capacityConsumer.service";
import { useLocation, useNavigate } from "react-router-dom";

const ListingsSearch = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const activeId = location?.search?.split("=")[1] || "";
  const role = useSelector((state) => state?.sessionState?.role);
  const companyId = useSelector(
    (state) => state?.sessionState?.userList?.[0]?.companyId
  );
  const capacityListings = useSelector(
    (state) => state?.listingsReducer?.allListingsSearch
  );
  const traderList = useSelector(
    (state) => state?.analystReducer?.companyTraders
  );
  console.debug(traderList);
  const dispatch = useDispatch();

  const [consumerOpen, setConsumerOpen] = useState(false);
  const [generatorOpen, setGeneratorOpen] = useState(false);

  const [connectData, setConnectData] = useState({});
  const [requestType, setRequestType] = useState("");
  const [activeTab, setActiveTab] = useState(false);

  useEffect(() => {
    getSpeceficTradersNew(companyId)(dispatch);
    if (role === "CONSUMER" || role === "UN_VERIFIED_CONSUMER") {
      getAllListingsConsumerLogin()(dispatch);
    } else if (role === "GENERATOR" || role === "UN_VERIFIED_GENERATOR") {
      getAllListingsGeneratorLogin()(dispatch);
    }
  }, [companyId, dispatch, role]);

  const handleCreateDuplicate = (id) => {
    let data = capacityListings?.find((item) => item.id === id);
    console.debug(id, data);
    setConnectData(data);
    if (role === "CONSUMER") {
      setConsumerOpen(true);
    } else if (role === "GENERATOR") {
      setGeneratorOpen(true);
    } else {
      alert("You are not allowed to create duplicate listing");
    }
  };

  const handleGeneratorSubmit = async (reqBody) => {
    if (!reqBody) {
      handleModalClose();
      return;
    }
    if (
      traderList?.filter((ele) => ele?.id === reqBody?.traderAssigned)?.length >
      0
    ) {
      setRequestType("TRADECONNECT");
    } else {
      setRequestType("DIRECT");
    }
    let res = await capacityGeneratorService.createGeneratorCapacity(reqBody);
    if (res.data.code === 200) {
      handlePlaceBid(
        res?.data?.data,
        traderList?.filter((ele) => ele?.id === reqBody?.traderAssigned)
          ?.length > 0
          ? "TRADECONNECT"
          : "DIRECT"
      );
    } else {
      console.error("Error creating generator capacity:", res.data.message);
    }
  };

  const handleConsumerSubmit = async (reqBody) => {
    if (!reqBody) {
      handleModalClose();
      return;
    }
    if (
      traderList?.filter((ele) => ele?.id === reqBody?.traderAssigned)?.length >
      0
    ) {
      setRequestType("TRADECONNECT");
    } else {
      setRequestType("DIRECT");
    }
    let res = await capacityConsumerService?.createConsumerCapacity(reqBody);
    if (res.data.code === 200) {
      handlePlaceBid(
        res?.data?.data,
        traderList?.filter((ele) => ele?.id === reqBody?.traderAssigned)
          ?.length > 0
          ? "TRADECONNECT"
          : "DIRECT"
      );
    } else {
      console.error("Error creating generator capacity:", res.data.message);
    }
  };

  const handlePlaceBid = (data, upreq) => {
    const requestBody = {
      name: data?.name,
      quantity: role === "GENERATOR" ? data?.sellEnergy : data?.purchaseEnergy,
      amount:
        data?.energyRateStr !== ""
          ? 0
          : role === "GENERATOR"
            ? data?.sellingCost || 0
            : data?.landingCost || 0,
      energyRateStr: data?.energyRateStr,
      generatorStatus: role === "GENERATOR" ? "PLACED" : "RECEIVED",
      consumerStatus: role === "CONSUMER" ? "PLACED" : "RECEIVED",
      capacityConsumerId: role === "CONSUMER" ? data?.id : connectData?.id,
      capacityGeneratorId: role === "CONSUMER" ? connectData?.id : data?.id,
      dateStartAt: data?.dateStartAt,
      dateEndAt: data?.dateEndAt,
      slotStartAt: data?.slotStartAt,
      slotEndAt: data?.slotEndAt,
      tcRequest: upreq === "TRADECONNECT",
      otcRequest: upreq === "DIRECT",
    };
    role === "GENERATOR"
      ? biddingGeneratorService
        .placeBidGenerator(requestBody)
        .then((response) => {
          if (response?.data?.code === 200) {
            toast.success(`${response?.data?.message}`, toastProperties);
            navigate("/dashboard");
            handleModalClose();
          } else if (response?.data?.code !== 200) {
            handleModalClose();
          }
        })
        .catch((error) => { })
      : biddingConsumerService
        .placeBidConsumer(requestBody)
        .then((response) => {
          if (response?.data?.code === 200) {
            toast.success(`${response?.data?.message}`, toastProperties);
            navigate("/consumer_dashboard");
            handleModalClose();
          } else if (response?.data?.code !== 200) {
            handleModalClose();
          }
        })
        .catch((error) => {
          console.error("API call error", error);
        });
  };

  const handleConnect = (data) => {
    handleModalClose();
  };

  const handleModalClose = () => {
    setConnectData({});
    setConsumerOpen(false);
    setGeneratorOpen(false);
  };

  return (
    <>
      {generatorOpen && (
        <PreviewModel
          isOpen={connectData}
          handleSubmit={handleGeneratorSubmit}
          directConnect={true}
        />
      )}

      {consumerOpen && (
        <ConsumerCapacityModal
          isOpen={connectData}
          handleSubmit={handleConsumerSubmit}
          directConnect={true}
          getMatchingProfilesCon={() => null}
        />
      )}
      <div
        className="card-box-search "
        style={{ display: "flex", flexDirection: "row" }}
      >
        <div className={`card-box-capacities p-4`} id="capacityListingNew">
          <div className="capacity_list_selection">
            <div
              onClick={() => setActiveTab(false)}
              className={!activeTab && "button_list_Active"}
            >
              Intrastate
            </div>
            <div
              onClick={() => setActiveTab(true)}
              className={activeTab && "button_list_Active"}
            >
              Interstate
            </div>
          </div>
          <div
            className={`${capacityListings?.filter((ele) => ele?.id === Number(activeId))
              ?.length > 0 && "border_bottom_container"
              }`}
          >
            {capacityListings?.filter((ele) => ele?.id === Number(activeId))
              ?.length > 0 && (
                <div className="view_active_cp">Counterparty Listings</div>
              )}
            {capacityListings
              ?.filter((ele) => ele?.id === Number(activeId))
              ?.map((item, i) => (
                <div key={i} className="mb-4 ">
                  <div className="bids-name bids-name-wrap-title">
                    <CapacityListingHeader
                      item={item}
                      handleCreateDuplicate={handleCreateDuplicate}
                    />
                  </div>
                </div>
              ))}
          </div>
          {capacityListings?.filter((ele) => ele?.id === Number(activeId))
            ?.length > 0 && (
              <div className="view_others_cp">
                View Others Counterparty Listings
              </div>
            )}
          {capacityListings?.length > 0 ? (
            capacityListings
              ?.filter((ele) => ele?.isInterstate === activeTab)
              ?.map((item, i) => {


                function isDateTimeGreater(dateTimeToCheck, referenceDateTime) {
                  const checkDateTime = new Date(dateTimeToCheck);
                  const refDateTime = new Date(referenceDateTime);

                  // Compare the two date-time values
                  return checkDateTime > refDateTime;
                }


                return (
                  <div key={i} className="mb-4 ">
                    <div className="bids-name bids-name-wrap-title">
                      <CapacityListingHeader
                        item={item}
                        handleCreateDuplicate={handleCreateDuplicate}
                        listingStatus={isDateTimeGreater(item?.bidEndAt, new Date())}
                      />
                    </div>
                  </div>
                )
              })
          ) : (
            <div style={{ marginTop: "200px" }}>
              <NodataFound />
            </div>
          )}
        </div>
        {/* <div className="card-box-filters p-2">
          <ListingsSearchFilter />
        </div> */}
      </div>
    </>
  );
};

export default ListingsSearch;
